import { useEffect, useState } from 'react';
import transactionAPI from '../../../../Data/Transaction';

import Init from '../../../../Init/Init';
import UtilityFunction from '../../../../Util/Util';

import './OrderDetail.scss';
import PrimaryButton from '../../../Utilities/PrimaryButton/PrimaryButton';
import LoadingPage from '../../../Utilities/LoadingPage/LoadingPage';

const { getFormattedDatetime, numberFormatting } = UtilityFunction;
const { FontAwesomeIcon } = Init;

const OrderDetail = (props) => {
    const [ data, setData ] = useState({});

    // const defaultImage = `${imageFolder}/placeholder.jpeg`;
    // const navigate = useNavigate();

    useEffect( () => {
        if(props.transactionCode !== '') {
            ( async () => {
                const response = await transactionAPI.getOrderDetail(props.transactionCode);
                
                if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
                    setData({
                        ...response.data
                    });

                    if( response.data.status === 0 ) {
                        props.clickPayNow(response.data.payment_link);
                    }
                }
            } )();
        }
    }, [props.transactionCode]);

    const constructRecipientInfo = () => {
        return `${ data.recipient_account?.bank_code } - ${ data.recipient_account?.account_no } A/N ${ data.recipient_account?.account_name }`;
    }

    const payNow = () => {
        // Open payment confirmation modal
        props.clickPayNow(data.payment_link);
    }

    const printNow = () => {
        // Simulate Ctrl + P
        window.print();
    }

    return data && data.shipping_info && data.items ? (
        <div className='order-detail'>
            {/* 
                Three parts:
                1. Header (Title, Description)
                2. Payment Info
                3. Payment Instruction
            */}
            <div className="order-detail-header">
                <h1 className='order-detail-header-title'>
                    Pesanan Anda
                </h1>
                {
                    data.payment_link ? '' : (
                        <span className="order-detail-header-desc">
                            Mohon lakukan pembayaran ke rekening { constructRecipientInfo() }
                        </span>
                    )
                }
            </div>
            <div className="order-detail-body">
                <div className="order-detail-info">
                    <hr />
                    <div className="info-item">
                        <span className="label">
                            Kode Transaksi
                        </span>
                        <span className="value">
                            { data.transaction_code }  
                        </span>
                    </div>
                    <hr />
                    <div className="info-item">
                        <span className="label">
                            Waktu Pesan
                        </span>
                        <span className="value">
                            { getFormattedDatetime(data.created_at, 'd M Y, H:i') }
                        </span>
                    </div>
                    <hr />
                    <div className="info-item">
                        <span className="label">
                            Status Pesanan
                        </span>
                        <span className="value">
                            { data.status_message }
                        </span>
                    </div>
                    <hr />
                    <div className="info-item transaction-notes">
                        <span className="label">
                            Catatan Tambahan
                        </span>
                        {
                            data.transaction_notes.split("\n\n").map( (row) => {
                                return (
                                    <span className="value">
                                        { row }
                                    </span>
                                )
                            } )
                        }
                        {/* <span className="value">
                            { data.transaction_notes }
                        </span> */}
                    </div>
                    <hr />
                </div>

                <div className="order-detail-product">
                    <h3 className="product-title">
                        Produk
                    </h3>
                    <table className="product-data">
                        <thead>
                            <tr>
                                <th>Nama Produk</th>
                                <th>Qty</th>
                                <th>Harga Satuan</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data?.items?.map( (item, index) => {
                                    return (
                                        <tr>
                                            <td>{ item.product_name } { item.variant_name ? `[${ item.variant_name }]` : "" }</td>
                                            <td>{ item.product_quantity } pcs</td>
                                            <td align="right">{ numberFormatting(item.product_price) }</td>
                                            <td align="right">{ numberFormatting(item.product_price * item.product_quantity) }</td>
                                        </tr>
                                    )
                                } )
                            }
                        </tbody>
                        <tbody className="product-total-info">
                            <tr>
                                <td colspan="3" className="product-label">Subtotal</td>
                                <td align="right">
                                    { numberFormatting(data.total_price) } 
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3" className="product-label">Biaya Cetak</td>
                                <td align="right">
                                    { numberFormatting(data.design_fee) }
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3" className="product-label">Biaya Platform</td>
                                <td align="right">
                                    { numberFormatting(data.mdr_fee) }
                                </td>
                            </tr>
                            <tr>
                                <td colspan="3" className="product-label">Ongkos Kirim</td>
                                <td align="right" className={`${ data.shipping_fee > 0  ? "" : "free"}`}>
                                { data.shipping_fee > 0  ? numberFormatting(data.shipping_fee) : "FREE" }</td>
                            </tr>
                            <tr>
                                <td colspan="3" className="product-label">PPN (11%)</td>
                                <td align="right">
                                    { numberFormatting(data.tax_fee) }
                                </td>
                            </tr>
                            <tr className="total">
                                <td colspan="3" className="product-label">Total</td>
                                <td align="right">
                                    { numberFormatting(data.total) }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="order-detail-shipping">
                    <div className="shipping-container">
                        <h3 className="shipping-title">
                            Detail Pemesan
                        </h3>

                        <table className="shipping-data">
                            <thead>
                                <tr>
                                    <th>Nama</th>
                                    <td>{ data.customer_name }</td>
                                </tr>
                                <tr>
                                    <th>No. WhatsApp</th>
                                    <td>{ data.customer_phone_no }</td>
                                </tr>
                                {
                                    data?.shipping_info.hasOwnProperty('province') ? (
                                        <>
                                            <tr>
                                                <th>Provinsi</th>
                                                <td>{ data?.shipping_info?.province }</td>
                                            </tr>
                                            <tr>
                                                <th>Kota / Kabupaten</th>
                                                <td>{ data?.shipping_info?.regency }</td>
                                            </tr>
                                            <tr>
                                                <th>Kecamatan</th>
                                                <td>{ data?.shipping_info?.district }</td>
                                            </tr>
                                            <tr>
                                                <th>Desa / Kelurahan</th>
                                                <td>{ data?.shipping_info?.village }</td>
                                            </tr>
                                            <tr>
                                                <th>Alamat</th>
                                                <td>{ data?.shipping_info?.address }</td>
                                            </tr>
                                            <tr>
                                                <th>Kode Pos</th>
                                                <td>{ data?.shipping_info?.zip_code }</td>
                                            </tr>
                                        </>
                                    ) : ""
                                }
                            </thead>
                            {
                                data?.shipping_info.hasOwnProperty('shippingData') &&
                                data?.shipping_info?.shippingData.map( (item, index) => {
                                    return (
                                        <tbody>
                                            <tr className="shipping-data-title">
                                                <th colspan="2"> Resi { index + 1 } </th>
                                            </tr>
                                            <tr>
                                                <th>No. Resi</th>
                                                <td>{ item.order_id }</td>
                                            </tr>
                                            <tr>
                                                <th>Berat Paket</th>
                                                <td>{ item.weight } gr</td>
                                            </tr>
                                            <tr>
                                                <th>Posisi</th>
                                                <td>{ item.shipping_status }</td>
                                            </tr>
                                        </tbody>
                                    )
                                } )
                            }
                        </table>
                    </div>
                </div>
            </div>
            <div className="order-detail-footer">
                {
                    data.status !== 0 || data.payment_link ? '' : (
                        <span className="footer-instruction">
                            Jika Anda <b>SUDAH</b> melakukan pembayaran silakan upload bukti transfer Anda untuk di verifikasi lebih lanjut oleh admin kami.
                        </span>
                    )
                }
                <div className="order-detail-footer-btn-container">
                    {
                        data.status === 0 ? (
                            <PrimaryButton
                                customClass={"btn-proceed"}
                                size={"md"}
                                onClick={() => payNow()}
                            >
                                Proceed to Pay
                            </PrimaryButton>
                        ) : ""
                    }
                    <PrimaryButton
                        customClass={"btn-proceed"}
                        size={"md"}
                        onClick={() => printNow()}
                    >
                        <FontAwesomeIcon icon={['fas', 'print']} /> Print Invoice
                    </PrimaryButton>
                </div>
            </div>
            {/* {
                data.status === 0 ? (
                ) : ""
            } */}
        </div>
    ) : (
        <LoadingPage />
    );
}

export default OrderDetail;